import { render, staticRenderFns } from "./FeedContent.vue?vue&type=template&id=702021cb&scoped=true&"
import script from "./FeedContent.vue?vue&type=script&lang=js&"
export * from "./FeedContent.vue?vue&type=script&lang=js&"
import style0 from "./FeedContent.vue?vue&type=style&index=0&id=702021cb&prod&lang=css&"
import style1 from "./FeedContent.vue?vue&type=style&index=1&id=702021cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702021cb",
  null
  
)

export default component.exports